import * as i0 from "@angular/core";
export class UtilService {
    constructor() { }
    cleanWrongAccentuation(replaceString) {
        const find = ["'a", "`a", "~a", "'e", "\\^e", "'o", "\\^o", "'u", "´u", "´e", "~o", "'i", "'A", "`A", "~A", "'E", "\\^E", "'O", "\\^O", "'U", "´U", "´E", "~O", "'I", "\\^a"];
        const replace = ["á", "à", "ã", "é", "ê", "ó", "ô", "ú", "ú", "é", "õ", "í", "Á", "À", "Ã", "É", "Ê", "Ó", "Ô", "Ú", "Ú", "É", "Õ", "Í", "â"];
        let regex = null;
        let newStr = replaceString;
        for (let i = 0; i < find.length; i++) {
            regex = new RegExp(find[i], "g");
            newStr = newStr.replace(regex, replace[i]);
        }
        return newStr;
    }
    ;
    bibtextEntriesToSelectedStudies(entries, added_by) {
        const selectedStudies = [];
        entries.forEach((entry) => {
            const columns = {
                document_type: entry.Fields.source && /scopus/gi.test(entry.Fields.source)
                    ? entry.Fields.document
                        ? entry.Fields.document.toUpperCase()
                        : entry.EntryType.toUpperCase()
                    : entry.EntryType.toUpperCase(),
                country: entry.Fields.affiliation
                    ? entry.Fields.affiliation.split(/, |,/g).pop().toUpperCase()
                    : entry.Fields.location
                        ? entry.Fields.location.split(/, |,/g).pop().toUpperCase()
                        : "",
            };
            for (const prop in entry.Fields) {
                const titles = ["der", "title"];
                for (const title of titles) {
                    if (entry.Fields[title]) {
                        columns.title = entry.Fields[title];
                    }
                }
                const dois = ["crossref", "doi"];
                for (const doi of dois) {
                    if (entry.Fields[doi]) {
                        columns.doi = entry.Fields[doi];
                    }
                }
                columns[prop.toLowerCase()] = entry.Fields[prop];
                if (entry.Fields.publisher && entry.Fields.publisher === "scielo") {
                    columns.author = columns.author.replace(/, /g, " and ");
                }
                columns.added_by = added_by;
            }
            columns.author = columns.author
                ? this.cleanWrongAccentuation(columns.author)
                : "";
            columns.title = columns.title ? this.cleanWrongAccentuation(columns.title) : "";
            if (columns.journal) {
                columns.journal = this.cleanWrongAccentuation(columns.journal);
            }
            selectedStudies.push({
                columns: Object.assign({}, columns),
                id: entry.id
            });
        });
        return selectedStudies;
    }
    generateHexColor() {
        let colors = ['E52B50', 'FFBF00', '9966CC', 'FBCEB1', '7FFFD4', '007FFF', '89CFF0', '0000FF', '0095B6', '8A2BE2', 'DE5D83',
            'CD7F32', '964B00', '800020', '702963', '960018', 'DE3163', '007BA7', '7FFF00', '50C878', '00FF3F', '808080', '4B0082', 'FF00FF',
            '800000', 'FF4500', '808000'
        ];
        function shuffle(array) {
            array.sort(() => Math.random() - 0.5);
        }
        shuffle(colors);
        return '#' + colors[5];
        // return '#'+(Math.random()*0xFFFFFF<<0).toString(16);
    }
    generateArrayHexColor(len) {
        let arr = [];
        for (let i = 0; i < len; i++) {
            arr.push(this.generateHexColor());
        }
        return arr;
    }
    // thanks to https://www.consolelog.io/group-by-in-javascript/
    groupBy(arr, prop) {
        return arr.reduce((groups, item) => {
            const val = item[prop];
            groups[val] = groups[val] || [];
            groups[val].push(item);
            return groups;
        }, {});
    }
    getColor(value) {
        const filters = {
            'unclassified': {
                color: 'secondary'
            },
            'accepted': {
                color: 'success'
            },
            'rejected': {
                color: 'danger'
            },
            'duplicated': {
                color: 'warning'
            }
        };
        return filters[value].color;
    }
    generateStringId(length) {
        let result = '';
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    mountCitation(authors, year = '', onlyFirstName = true) {
        const authorsSplitted = authors.split(' and ');
        let citation = '';
        if (authorsSplitted.length > 3) {
            const firstAuthor = authorsSplitted[0], firstNameAuthor = firstAuthor.split(',')[0];
            citation += `${firstNameAuthor} ${'et al'.italics()}.`;
        }
        else {
            const countAuthors = authorsSplitted.length;
            switch (countAuthors) {
                case 2:
                    if (onlyFirstName) {
                        citation += `${this.getFirstNameAuthor(authorsSplitted[0])}; ${this.getFirstNameAuthor(authorsSplitted[1])}`;
                    }
                    else {
                        citation += `${authorsSplitted[0]}; ${authorsSplitted[1]}`;
                    }
                    break;
                case 3:
                    if (onlyFirstName) {
                        citation +=
                            `${this.getFirstNameAuthor(authorsSplitted[0])}; ${this.getFirstNameAuthor(authorsSplitted[1])}; ${this.getFirstNameAuthor(authorsSplitted[2])}`;
                    }
                    else {
                        citation +=
                            `${authorsSplitted[0]}; ${authorsSplitted[1]}; ${authorsSplitted[2]}`;
                    }
                    break;
                default:
                    if (onlyFirstName) {
                        citation += `${this.getFirstNameAuthor(authorsSplitted[0])}`;
                    }
                    else {
                        citation += `${authorsSplitted[0]}`;
                    }
            }
        }
        if (year) {
            citation += `, ${year}`;
        }
        return citation;
    }
    getFirstNameAuthor(name) {
        const index = name.indexOf(',');
        if (index > -1) {
            return name.slice(0, index);
        }
        return name;
    }
    translateStatus(sta) {
        const status = {
            define: {
                text: 'concluído',
                color: 'success'
            },
            review: {
                text: 'revisar',
                color: 'danger'
            },
            discard: {
                text: 'descartado',
                color: 'secondary'
            }
        };
        return status[sta] || '';
    }
    translateRole(slug) {
        const roles = {
            author: 'Autor',
            advisor: 'Orientador',
            'co-supervisor': 'Coorientador',
            mentor: 'Mentor'
        };
        return roles[slug] || '';
    }
    slugify(input) {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
        const p = new RegExp(a.split('').join('|'), 'g');
        return input.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
            .replace(/&/g, '-and-') // Replace & with 'and'
            .replace(/[^\w\-]+/g, '') // Remove all non-word characters
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, ''); // Trim - from end of text
    }
}
UtilService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilService_Factory() { return new UtilService(); }, token: UtilService, providedIn: "root" });
